// Level system configuration - Chef Hierarchy (Rebalanced for 3 months daily usage)
// Max level 30 at 18,550 points
export const LEVELS = [
  { level: 1, name: "Kitchen Helper", pointsRequired: 0, color: "#6B7280" },
  { level: 2, name: "Dishwasher", pointsRequired: 60, color: "#4B5563" },
  { level: 3, name: "Apprentice Chef", pointsRequired: 140, color: "#374151" },
  { level: 4, name: "Newbie Chef", pointsRequired: 260, color: "#1F2937" },
  { level: 5, name: "Line Cook", pointsRequired: 410, color: "#059669" },
  { level: 6, name: "Fry Cook", pointsRequired: 600, color: "#0D9488" },
  { level: 7, name: "Prep Chef", pointsRequired: 830, color: "#0891B2" },
  { level: 8, name: "Pastry Novice", pointsRequired: 1090, color: "#7C3AED" },
  { level: 9, name: "Sous Chef", pointsRequired: 1400, color: "#DC2626" },
  { level: 10, name: "Chef de Partie", pointsRequired: 1760, color: "#B91C1C" },
  { level: 11, name: "Junior Chef", pointsRequired: 2160, color: "#EA580C" },
  { level: 12, name: "Pantry Chef", pointsRequired: 2610, color: "#C2410C" },
  { level: 13, name: "Saucier", pointsRequired: 3110, color: "#16A34A" },
  { level: 14, name: "Grill Master", pointsRequired: 3650, color: "#15803D" },
  { level: 15, name: "Patissier", pointsRequired: 4230, color: "#2563EB" },
  { level: 16, name: "Butcher Chef", pointsRequired: 4870, color: "#1D4ED8" },
  { level: 17, name: "Fish Chef", pointsRequired: 5540, color: "#7C2D12" },
  { level: 18, name: "Vegetable Chef", pointsRequired: 6270, color: "#A21CAF" },
  { level: 19, name: "Rotisseur", pointsRequired: 7040, color: "#86198F" },
  { level: 20, name: "Sous Chef de Cuisine", pointsRequired: 7860, color: "#BE123C" },
  { level: 21, name: "Executive Chef", pointsRequired: 8720, color: "#9F1239" },
  { level: 22, name: "Head Chef", pointsRequired: 9630, color: "#CA8A04" },
  { level: 23, name: "Master Chef", pointsRequired: 10580, color: "#A16207" },
  { level: 24, name: "Celebrity Chef", pointsRequired: 11580, color: "#DC2626" },
  { level: 25, name: "Michelin-Star Chef", pointsRequired: 12630, color: "#B91C1C" },
  { level: 26, name: "Iron Chef", pointsRequired: 13720, color: "#7C2D12" },
  { level: 27, name: "Legendary Chef", pointsRequired: 14860, color: "#581C87" },
  { level: 28, name: "World-Class Chef", pointsRequired: 16040, color: "#4C1D95" },
  { level: 29, name: "Culinary Genius", pointsRequired: 17270, color: "#1E40AF" },
  { level: 30, name: "Kitchen God", pointsRequired: 18550, color: "#B91C1C" }
];

export const calculateLevel = (points) => {
  for (let i = LEVELS.length - 1; i >= 0; i--) {
    if (points >= LEVELS[i].pointsRequired) {
      return LEVELS[i];
    }
  }
  return LEVELS[0];
};

export const calculateProgress = (points) => {
  const currentLevel = calculateLevel(points);
  const currentLevelIndex = LEVELS.findIndex(level => level.level === currentLevel.level);

  if (currentLevelIndex === LEVELS.length - 1) {
    return { percentage: 100, pointsToNext: 0, nextLevel: null };
  }

  const nextLevel = LEVELS[currentLevelIndex + 1];
  const pointsInCurrentLevel = points - currentLevel.pointsRequired;
  const pointsNeededForNext = nextLevel.pointsRequired - currentLevel.pointsRequired;
  const percentage = Math.min(100, (pointsInCurrentLevel / pointsNeededForNext) * 100);

  return {
    percentage: Math.round(percentage),
    pointsToNext: nextLevel.pointsRequired - points,
    nextLevel: nextLevel
  };
};

export const getLevelBadge = (level) => {
  const badges = {
    1: "\uD83E\uDDF9",
    2: "\uD83C\uDF7D\uFE0F",
    3: "\uD83D\uDC68\u200D\uD83C\uDF73",
    4: "\uD83E\uDD44",
    5: "\uD83C\uDF73",
    6: "\uD83C\uDF5F",
    7: "\uD83D\uDD2A",
    8: "\uD83E\uDDC1",
    9: "\uD83D\uDC68\u200D\uD83C\uDF73",
    10: "\uD83E\uDD58",
    11: "\uD83C\uDF7D\uFE0F",
    12: "\uD83E\uDD6C",
    13: "\uD83C\uDF72",
    14: "\uD83D\uDD25",
    15: "\uD83C\uDF82",
    16: "\uD83E\uDD69",
    17: "\uD83D\uDC1F",
    18: "\uD83E\uDD55",
    19: "\uD83C\uDF56",
    20: "\uD83D\uDC68\u200D\uD83C\uDF73",
    21: "\uD83D\uDC54",
    22: "\uD83D\uDC51",
    23: "\u2B50",
    24: "\uD83C\uDF1F",
    25: "\uD83C\uDFC6",
    26: "\u2694\uFE0F",
    27: "\uD83D\uDCAB",
    28: "\uD83C\uDF0D",
    29: "\uD83E\uDDE0",
    30: "\uD83C\uDFDB\uFE0F"
  };
  return badges[level] || "\uD83E\uDDF9";
};

export const getLevelDescription = (level) => {
  const descriptions = {
    1: "Starting at the bottom, learning the basics",
    2: "Keeping the kitchen clean and organized",
    3: "Learning from experienced chefs",
    4: "Getting comfortable with basic techniques",
    5: "Working the line with speed and precision",
    6: "Mastering the art of frying",
    7: "Preparing ingredients with skill",
    8: "Creating beautiful desserts and pastries",
    9: "Assisting the head chef in all tasks",
    10: "Leading a specific station in the kitchen",
    11: "Growing in culinary knowledge and skill",
    12: "Managing pantry and ingredient inventory",
    13: "Creating perfect sauces and soups",
    14: "Mastering the grill and open flame",
    15: "Specializing in pastry and dessert arts",
    16: "Expert in meat preparation and butchery",
    17: "Specializing in fish and seafood",
    18: "Master of vegetable preparation",
    19: "Expert in roasting and rotisserie",
    20: "Second-in-command of the entire kitchen",
    21: "Managing kitchen operations and staff",
    22: "Leading the entire culinary team",
    23: "Achieving mastery in all cooking arts",
    24: "Recognized for culinary excellence",
    25: "Awarded the highest culinary honor",
    26: "Battling in culinary competitions",
    27: "Achieving legendary status in cooking",
    28: "Recognized worldwide for culinary skill",
    29: "Possessing extraordinary culinary talent",
    30: "The ultimate master of the kitchen"
  };
  return descriptions[level] || "Starting your culinary journey";
};
